import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center justify-center w-16 h-16 rounded-full bg-gray-50",
  "data-testid": "empty-state-icon"
}
const _hoisted_2 = { class: "flex flex-col gap-1" }
const _hoisted_3 = {
  class: "text-gray-600 font-medium",
  "data-testid": "empty-state-title"
}
const _hoisted_4 = {
  key: 0,
  class: "text-sm text-gray-400 max-w-md",
  "data-testid": "empty-state-description"
}

export type EmptyStateVariant = 'plain' | 'dashed'


export default /*#__PURE__*/_defineComponent({
  __name: 'EmptyState',
  props: {
    title: {},
    description: { default: undefined },
    icon: { default: undefined },
    variant: { default: 'plain' }
  },
  setup(__props: any) {



const variantClasses: Record<EmptyStateVariant, string> = {
  plain: '',
  dashed: 'border-2 border-dashed border-gray-200 rounded-lg bg-gray-50'
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-full flex flex-col items-center justify-center gap-3 py-12 text-center", variantClasses[_ctx.variant]]),
    "data-testid": "empty-state"
  }, [
    (_ctx.icon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_icon, {
            icon: _ctx.icon,
            size: "36",
            class: "text-gray-400"
          }, null, 8, ["icon"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.title), 1),
      (_ctx.description)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.description), 1))
        : _createCommentVNode("", true)
    ]),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})